/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MedicalHistoryDownloadDto } from '../model';
/**
 * MedicalHistoryControllerApi - axios parameter creator
 * @export
 */
export const MedicalHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalHistoryDownloads: async (patientId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getMedicalHistoryDownloads', 'patientId', patientId)
            const localVarPath = `/api/medical-history/{patientId}/history`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} patientId 
         * @param {boolean} observations 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<number>} [epricrisisIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalHistoryPdf: async (patientId: number, observations: boolean, dateFrom?: string, dateTo?: string, epricrisisIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getMedicalHistoryPdf', 'patientId', patientId)
            // verify required parameter 'observations' is not null or undefined
            assertParamExists('getMedicalHistoryPdf', 'observations', observations)
            const localVarPath = `/api/medical-history/{patientId}/pdf`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (observations !== undefined) {
                localVarQueryParameter['observations'] = observations;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substr(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substr(0,10) :
                    dateTo;
            }

            if (epricrisisIds) {
                localVarQueryParameter['epricrisisIds'] = epricrisisIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedicalHistoryControllerApi - functional programming interface
 * @export
 */
export const MedicalHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedicalHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedicalHistoryDownloads(patientId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<MedicalHistoryDownloadDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalHistoryDownloads(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} patientId 
         * @param {boolean} observations 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<number>} [epricrisisIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMedicalHistoryPdf(patientId: number, observations: boolean, dateFrom?: string, dateTo?: string, epricrisisIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalHistoryPdf(patientId, observations, dateFrom, dateTo, epricrisisIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MedicalHistoryControllerApi - factory interface
 * @export
 */
export const MedicalHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedicalHistoryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalHistoryDownloads(patientId: number, options?: any): Promise<Array<MedicalHistoryDownloadDto>> {
            return localVarFp.getMedicalHistoryDownloads(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} patientId 
         * @param {boolean} observations 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<number>} [epricrisisIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalHistoryPdf(patientId: number, observations: boolean, dateFrom?: string, dateTo?: string, epricrisisIds?: Array<number>, options?: any): Promise<any> {
            return localVarFp.getMedicalHistoryPdf(patientId, observations, dateFrom, dateTo, epricrisisIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedicalHistoryControllerApi - object-oriented interface
 * @export
 * @class MedicalHistoryControllerApi
 * @extends {BaseAPI}
 */
export class MedicalHistoryControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public getMedicalHistoryDownloads(patientId: number, options?: AxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).getMedicalHistoryDownloads(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} patientId 
     * @param {boolean} observations 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {Array<number>} [epricrisisIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalHistoryControllerApi
     */
    public getMedicalHistoryPdf(patientId: number, observations: boolean, dateFrom?: string, dateTo?: string, epricrisisIds?: Array<number>, options?: AxiosRequestConfig) {
        return MedicalHistoryControllerApiFp(this.configuration).getMedicalHistoryPdf(patientId, observations, dateFrom, dateTo, epricrisisIds, options).then((request) => request(this.axios, this.basePath));
    }
}
